module.exports = "//a.spikex.com/sigma/frontend-ssr-web-index/_next/static/images/poster-boom-f92f64721ab26976adc974f906496f21.gif";